import { v } from "convex/values"

export const CATEGORIES = [
  { value: "general", label: "General" },
  { value: "announcements", label: "Announcements" },
  { value: "financing", label: "Financing" },
  { value: "inventory", label: "Inventory" },
  { value: "service", label: "Service" },
  { value: "marketing", label: "Marketing" },
  { value: "operations", label: "Operations" },
  { value: "technology", label: "Technology" },
] as const

export type ThreadCategory = (typeof CATEGORIES)[number]["value"]

export const categoryValidator = v.union(
  v.literal("general"),
  v.literal("announcements"),
  v.literal("financing"),
  v.literal("inventory"),
  v.literal("service"),
  v.literal("marketing"),
  v.literal("operations"),
  v.literal("technology"),
)

export const threadStatusValidator = v.union(
  v.literal("open"),
  v.literal("resolved"),
  v.literal("closed"),
)

export const messageKindValidator = v.union(v.literal("initial"), v.literal("reply"))

export const TAGS = [
  "question",
  "tip",
  "discussion",
  "help-wanted",
  "new-dealer",
  "best-practice",
  "vendor",
  "compliance",
  "oem",
  "used-cars",
  "new-cars",
  "ev",
  "cdp",
  "crm",
  "dms",
] as const

export type ThreadTag = (typeof TAGS)[number]

export const MAX_TAGS = 5
export const MAX_PINNED_PER_CATEGORY = 3
